import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ecosystemContent } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import useDocumentTitle from '../hooks/useDocumentTitle';
import EcosystemDiagram from '../components/sections/EcosystemDiagram';

const EcosystemPage = () => {
  const { language, t, pick } = useLanguage();
  useDocumentTitle(language === 'fr' ? 'Écosystème' : 'Ecosystem');
  const e = {
    en: { advantages: 'Integrated Model Advantages', ourCompanies: 'Our Companies', eightSpecialized: 'Eight Specialized Platforms', eachCompany: 'Each company has a clear mandate, working autonomously yet strategically interconnected.', partnership: 'Interested in Partnership?', partnershipSub: 'We collaborate with investors, technology partners and institutions.', explorePart: 'Explore Partnerships' },
    fr: { advantages: 'Avantages du modèle intégré', ourCompanies: 'Nos entreprises', eightSpecialized: 'Huit plateformes spécialisées', eachCompany: 'Chaque entreprise a un mandat clair, travaillant de manière autonome mais stratégiquement interconnectée.', partnership: 'Intéressé par un partenariat ?', partnershipSub: 'Nous collaborons avec des investisseurs, partenaires technologiques et institutions.', explorePart: 'Explorer les partenariats' }
  }[language];

  return (
    <div className="pt-20">
      <section className="section-padding-lg bg-[#1a1c1b] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute -top-20 -right-20 w-[600px] h-[600px] border border-[#5B7A8A] rounded-full"></div>
          <div className="absolute bottom-20 -left-20 w-[400px] h-[400px] border border-[#5B7A8A] rounded-full"></div>
        </div>
        <div className="container-swg relative z-10">
          <div className="max-w-4xl">
            <span className="caption text-[#5B7A8A] block mb-4">{pick(ecosystemContent.title)}</span>
            <h1 className="heading-1 text-white mb-8">{pick(ecosystemContent.intro.title)}</h1>
            <div className="accent-line mb-8"></div>
            <p className="body-large max-w-2xl mb-8">{pick(ecosystemContent.intro.text)}</p>
            <div className="grid sm:grid-cols-2 gap-4 max-w-xl">
              {pick(ecosystemContent.intro.connections).map((connection, index) => (
                <div key={index} className="flex items-center gap-3 text-[#5B7A8A]">
                  <div className="w-2 h-2 bg-[#5B7A8A] rounded-full"></div>
                  <span className="text-sm font-medium">{connection}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding bg-[#302f2c]/30 border-t border-[rgba(91,122,138,0.3)]">
        <div className="container-swg">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="caption text-[#5B7A8A] block mb-4">{pick(ecosystemContent.valueCreation.title)}</span>
              <h2 className="heading-2 text-white mb-6">{e.advantages}</h2>
              <div className="accent-line mb-8"></div>
              <p className="body-large">{pick(ecosystemContent.valueCreation.intro)}</p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {pick(ecosystemContent.valueCreation.points).map((point, index) => (
                <div key={index} className="swg-card rounded-xl p-6">
                  <div className="text-3xl font-bold text-[#5B7A8A] mb-2">0{index + 1}</div>
                  <p className="text-white font-medium">{point}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding-lg bg-[#1a1c1b]">
        <div className="container-swg">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="caption text-[#5B7A8A] block mb-4">{e.ourCompanies}</span>
            <h2 className="heading-2 text-white mb-6">{e.eightSpecialized}</h2>
            <p className="body-large">{e.eachCompany}</p>
          </div>

          <div className="relative max-w-2xl mx-auto py-8">
            <EcosystemDiagram />
          </div>
        </div>
      </section>

      <section className="section-padding bg-[#1a1c1b] border-t border-[rgba(91,122,138,0.3)]">
        <div className="container-swg">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div>
              <h2 className="heading-3 text-white mb-2">{e.partnership}</h2>
              <p className="text-[#9AACB8]">{e.partnershipSub}</p>
            </div>
            <Link to="/partnerships" className="btn-primary">
              {e.explorePart}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EcosystemPage;
